module.exports = __webpack_public_path__ + "static/media/pinergy.f85b3f72.png";